import { ReactNode } from 'react';
import UserThumbnail from '@mindtickle/user-thumbnail';
import Tooltip from '@mindtickle/tooltip';

import {
  StyledDropdownTriggerWrapper,
  StyledProfileDropdown,
  PROFILE_THUMBNAIL_SIZE,
} from './style';
import messages from './messages';
import { IntlType, UserInfo } from '../../type';
import { getPopupContainerOnBody } from '@mindtickle/utils';

interface ProfileDropdownProps {
  options: ReactNode;
  user: UserInfo;
  intl: IntlType;
  isVisible: boolean;
  handleVisibilityChange: (state: boolean) => void;
  overlayClassName?: string;
}

const ProfileDropdown = ({
  options,
  user,
  intl,
  isVisible,
  handleVisibilityChange,
  overlayClassName = 'gh-profile-dropdown-container',
}: ProfileDropdownProps) => (
  <StyledProfileDropdown
    options={options}
    onVisibleChange={handleVisibilityChange}
    visible={isVisible}
    align={{ offset: [0, 12] }}
    overlayClassName={overlayClassName}
  >
    <Tooltip
      title={intl.formatMessage(messages.PROFILE)}
      getPopupContainer={getPopupContainerOnBody}
    >
      <StyledDropdownTriggerWrapper $isActive={isVisible} data-testid="icon-user-profile">
        <UserThumbnail
          isExpanded={false}
          avatarProps={{ size: PROFILE_THUMBNAIL_SIZE }}
          name={user.name || user.email}
          src={user.image}
        />
      </StyledDropdownTriggerWrapper>
    </Tooltip>
  </StyledProfileDropdown>
);

export default ProfileDropdown;
